const baseUrl = '/api/v1/volumes/autoscaling/rules';

// The API resolves a rule only within its owning account, so org-level users
// must pass the rule's accountId.
export function buildDeleteRuleUrl(rule: { ruleId: string; accountId?: string }) {
  const params = new URLSearchParams();
  if (rule.accountId) {
    params.set('accounts', rule.accountId);
  }
  return params.size ? `${baseUrl}/${rule.ruleId}?${params.toString()}` : `${baseUrl}/${rule.ruleId}`;
}
